export default __webpack_public_path__ + "static/media/109t.9ad8691f.jpg";